import React from 'react';
import * as mobx from 'mobx';
import * as mobxReact from 'mobx-react';
import OptionsButton from '../../global/options-button/options-button';
import { CommonPopupBodyFooterLayout } from '../../global/common-popup/common-popup-body-footer-layout';
import { FormField } from '../../global/form/form-field/form-field';
import { DefaultCloseSubWindowButton } from '../../global/sub-window/common/common-close-sub-window-buttons';
import { ADD_TEXT, APPLY_TEXT, CANCEL_TEXT, REPLACE_TEXT } from '../../../constants/common-labels.constants';
import { TelephoneFormVM } from './telephone-form.viewmodel';
import * as COMMON_TEXTS from '../../../constants/common-labels.constants';
import UploadButton, { FILE_TYPE } from '../../_events/_manage-event/shared/upload-button';
import { ONLY_SPACES_REG_EXP, SPACE_IN_BEGIN_REG_EXP } from '../../../constants/regex.constants';
import {
    DEACTIVATE_NUMBER_SET_TEXT,
    DOWNLOAD_NUMBER_SET,
    FILE_ARCHIVE_TEXT,
    NAME_TEXT,
    ONE_TAP_FORMULA_TEXT,
    PROVIDER_TEXT,
    telephoneDataIsBeingSavedText,
} from '../../../constants/telephone-number-set-form.text';
import DefaultButton from '../../global/default-button/default-button';
import { FileInput } from '../../_events/_manage-event/shared/file-input/file-input';
import { AudioBridgeProvider } from '../../../api/connections.dao';
import { AudioBridgeProviderLabel } from '../../../infrastructure/utils/common.utils';

const TelephoneNumberSetFormPresentation = mobxReact.observer(
    (props: { vm: TelephoneFormVM }) => {
        const { vm } = props;
        const { intl } = vm;
        const formData = vm.getFormDataVM();
        formData.setIsEdit(!!formData.audioProviderId);

        const formSubmitHandler = () => {
            return vm.handleSubmit(formData.isEditEnabled ? 'Edit' : 'Create');
        };

        const removeOnlySpacesFromField = mobx.action(
            (value: string, key: string) => {
                if (!value.replace(ONLY_SPACES_REG_EXP, '').length) {
                    formData[key] = '';
                }
            }
        );

        const numberSetOptions = [
            {
                label: intl.formatMessage(DEACTIVATE_NUMBER_SET_TEXT),
                action: vm.inactivateNumberSet,
                danger: true
            }
        ].filter(Boolean); // filter returns array without null or false elements

        const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const fileList = e.target.files;
            if (fileList) {
                const file = fileList[0];
                formData.setTelephoneArchive(file);
            }
        };

        return (
            <CommonPopupBodyFooterLayout
                body={
                    <div className="user-form">
                        <div className="oe-form">
                            <div className="oe-form__body">
                                <FormField
                                    label={intl.formatMessage(NAME_TEXT)}
                                >
                                    <input
                                        type="text"
                                        className="oe-form-field__control"
                                        value={formData.name}
                                        onChange={({ target: { value } }) => formData.setName(value.replace(SPACE_IN_BEGIN_REG_EXP, ''))}
                                        onBlur={mobx.action(({ target: { value } }) => removeOnlySpacesFromField(value, 'name'))}
                                    />
                                    {formData.showValidationErrors() ? (
                                        <div className="oe-form-field__error">
                                            {formData.getNameError()}
                                        </div>
                                    ) : null}
                                </FormField>
                                <FormField
                                    label={intl.formatMessage(PROVIDER_TEXT)}
                                >
                                    <select
                                        className="oe-form-field__control"
                                        value={formData.provider}
                                        onChange={({ target: { value } }) => formData.setProvider(value.replace(SPACE_IN_BEGIN_REG_EXP, ''))}
                                        disabled={formData.isEditEnabled}
                                    >
                                        {Object.keys(AudioBridgeProvider).map((item: AudioBridgeProvider) =>
                                            <option
                                                key={item}
                                                value={AudioBridgeProvider[item]}
                                            >
                                                {AudioBridgeProviderLabel[item]}
                                            </option>
                                        )}
                                    </select>
                                    {formData.showValidationErrors() ? (
                                        <div className="oe-form-field__error">
                                            {formData.getProviderError()}
                                        </div>
                                    ) : null}
                                </FormField>
                                <FormField
                                    label={intl.formatMessage(
                                        ONE_TAP_FORMULA_TEXT
                                    )}
                                >
                                    <input
                                        type="text"
                                        className="oe-form-field__control"
                                        value={formData?.oneTapFormula}
                                        onChange={({ target: { value } }) => formData.setOneTapFormula(value)}
                                        onBlur={mobx.action(({ target: { value } }) => removeOnlySpacesFromField(value, 'oneTapFormula'))}
                                    />
                                </FormField>
                                <FormField
                                    label={intl.formatMessage(
                                        FILE_ARCHIVE_TEXT
                                    )}
                                >
                                    {!formData.isEditEnabled && <UploadButton
                                        fileName={
                                            formData.telephoneArchive?.name
                                        }
                                        onChange={formData.setTelephoneArchive}
                                        uploadedFileType={FILE_TYPE.CSV}
                                    />}
                                    {formData.isEditEnabled && <div>
                                        <input
                                            className='oe-form-field__control m-right-11px uploaded-img__name--title m-bottom-15px'
                                            type='text'
                                            value={formData.telephoneArchive?.name || formData.telephoneArchiveName}
                                            disabled={true}
                                        />
                                        <div className='image-input flex w-100 uploaded-img__controls'>
                                            <DefaultButton
                                                className='download-number-set-button m-right-15px'
                                                text={intl.formatMessage(DOWNLOAD_NUMBER_SET)}
                                                onClick={vm.downloadNumberSet}
                                            />
                                            <FileInput
                                                className='default-button--slim default-button--options'
                                                type='default'
                                                title={intl.formatMessage(REPLACE_TEXT)}
                                                acceptedFileTypes={FILE_TYPE.CSV}
                                                onChange={handleFileChange}
                                            />
                                        </div>
                                    </div>}
                                    {formData.showValidationErrors() && (
                                        <div className="oe-form-field__error">
                                            {formData.getTelephoneArchiveError()}
                                        </div>
                                    )}
                                </FormField>
                            </div>

                            {formData.serverErrorMessage && (
                                <div className="oe-form-field__error">
                                    {formData.serverErrorMessage}
                                </div>
                            )}
                        </div>
                    </div>
                }
                footer={
                    <>
                        {vm.isSaving() && (
                            <span className="oe-popup-layout__footer-status-area">
                                {telephoneDataIsBeingSavedText()}
                            </span>
                        )}

                        <div className="buttons-block buttons-block--from-right">

                            <DefaultCloseSubWindowButton
                                text={intl.formatMessage(formData.isEditEnabled ? APPLY_TEXT : ADD_TEXT)}
                                modifier={['fat', 'confirm-safe']}
                                onClick={formSubmitHandler}
                                disabled={vm.isSaving()}
                            />
                            <DefaultCloseSubWindowButton
                                text={intl.formatMessage(CANCEL_TEXT)}
                            />
                            {!!numberSetOptions.length && (<OptionsButton
                                className='options-button--right-margin-auto'
                                modifier={['fat', 'options']}
                                label={intl.formatMessage(COMMON_TEXTS.MORE_BUTTON_TEXT)}
                                options={numberSetOptions}
                                position='top'
                                align='start'
                            />)}
                        </div>
                    </>
                }
            />
        );
    }
);

export { TelephoneNumberSetFormPresentation };
